const peppolPartyRegistration = {
  PeppolParty: "Peppol Party",
  peppol_party_registration: "Peppol Party Registration",
  add_configuration: "Register Peppol Party",
  edit_configuration: "Edit Peppol Party",
  company_id: "Company ID",
  select_company_id: "Select company ID",
  country: "Country",
  tax_registration_number: "Tax Registration Number",
  name: "Name",
  email: "Email",
  status: "Status",
  registered: "Registered",
  pending: "Pending",
  processing: "Processing",
  failed: "Failed",
  created_on: "Created On",
  updated_on: "Updated On",
  peppol_participant_id: "Peppol Participant ID",
  scheme_id: "Scheme ID",
  cancel: "Cancel",
  create: "Create",
  update: "Update",
  edit: "Edit",
  delete: "Delete",
  actions: "Actions",
  configuration: "Configuration",
  Dashboard: "Dashboard",
  something_went_wrong: "Something went wrong",
  no_peppol_parties_found: "No Peppol parties found",
  no_peppol_inbox_found: "No Peppol Inbox found",
  peppol_party_created_successfully: "Peppol party registered successfully",
  peppol_party_updated_successfully: "Peppol party updated successfully",
  peppol_party_deleted_successfully: "Peppol party deleted successfully",
  delete_peppol_party_title: "Delete Peppol Party",
  delete_peppol_party_description: "Are you sure you want to delete this Peppol party registration?",
  company_id_required: "Company ID is required",
  country_required: "Country is required",
  tax_registration_number_required: "Tax registration number is required",
  name_required: "Name is required",
  email_required: "Email is required",
  email_invalid: "Enter a valid email address",
  legal_representative_missing_text: "Legal representative not found, please",
  update_first: "update first",
  "legal_representative_not_found": "Legal representative not found, please update first",
  "party_registration_in_processing": "Party registration is currently processing",
  "party_not_found": "Peppol party not found",
  "party_not_registered": "Peppol party is not registered",
  "party_already_registered": "Peppol party is already registered",
  "party_configuration_not_found": "Peppol party configuration not found",
  "party_registration_id_not_found": "Peppol party registration ID not found",
  "register_party_for_approval": "Register Party for Approval",
  "set_state": "Set State",
  "notify_failure": "Notify Failure",
  "unregister_peppol_party": "Unregister Peppol Party",
  "notify_unregister": "Notify Unregister",
  proof_of_ownership: "Proof of Ownership",
  proof_of_ownership_required: "Proof of ownership is required",
  proof_of_ownership_invalid: "Invalid file type. Only PDF files are allowed.",
  unregister: "Unregister",
  unregistered: "Unregistered",
  unregister_party: "Unregister Peppol Party",
  unregister_party_description: "Are you sure you want to unregister this Peppol party?",
  unregistration_processing: "Unregistration Processing",
  unregistration_failed: "Unregistration Failed",
  enter_unregistration_reason: "Enter reason to unregister",
  reason_required: "Reason is required to unregister",
  peppol_party_unregistered_successfully: "Peppol party unregistered successfully",
  confirm_unregistration: "Confirm Unregistration",
  confirm_unregistration_description: "Are you sure you want to proceed with the unregistration?",
  history: "View history",
  job_history: "Job History",
  execution_path: "Execution path",
  no_history_found: "No history found",
  provider: "Provider",
  message: "Message",
  close: "Close",
  success: "Success",
  running: "Running",

};

export default peppolPartyRegistration;
